import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Page from '@lib/components/v2/Page';
import { Checkbox } from '@lib/components/v2/Form';
import { localizedString } from '@languages';

import parse from 'html-react-parser';
import classes from './Privacy.style.module.scss';

const Privacy = ({ privacyContent, onAccept, onSelectLanguage }) => {
  const [state, setState] = useState({ confirmed: false });
  const { backurl } = document.body.dataset;
  let buttons = [
    {
      label: localizedString('continue'),
      disabled: !state.confirmed,
      onClick: () => {
        if (state.confirmed) {
          onAccept();
        }
      }
    }
  ];

  if (backurl) {
    buttons = [
      {
        label: localizedString('back'),
        variant: 'transparent',
        onClick: () => {
          window.location.href = backurl;
        }
      },
      {
        label: localizedString('continue'),
        disabled: !state.confirmed,
        onClick: () => {
          if (state.confirmed) {
            onAccept();
          }
        }
      }
    ];
  }

  const {
    APP_NAME,
    FLOW_V2_PRIVACY_CHECKBOX_LABEL = localizedString(
      'confirmThatIHaveReadAndAcceptThePrivacyConsent'
    )
  } = process.env;

  let privacyContentElements;
  if (!privacyContent) {
    const privacyContents = localizedString('privacyContents');
    const contents = privacyContents[APP_NAME].voi || [];
    privacyContentElements = contents.map((item, index) => {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index}>
          {parse(item)}
          <br />
          <br />
        </div>
      );
    });
  } else {
    privacyContentElements = parse(privacyContent);
  }

  return (
    <Page
      title={localizedString('privacyTitle')}
      isPrivacy
      buttons={buttons}
      className={classes.wrapper}
      onSelectLanguage={onSelectLanguage}
    >
      <div className={classes.heading}>{localizedString('privacyConsent')}</div>
      <div className={classes.content}>
        {privacyContentElements}

        <Checkbox
          id="confirm"
          value={state.confirmed}
          onChange={(value) => setState({ confirmed: value })}
          label={FLOW_V2_PRIVACY_CHECKBOX_LABEL}
        />
      </div>
    </Page>
  );
};

Privacy.propTypes = {
  onAccept: PropTypes.func,
  privacyContent: PropTypes.any,
  onSelectLanguage: PropTypes.func
};

export default Privacy;
